import type { LoadWorkingOrderAction } from "actions/working-order-state";
import { WORKING_ORDER } from "constants/action-types";
import me from "models/me";
import type { IWorkingOrder } from "types/cart";
import cookie from "react-cookie";
import _ from "lodash";

export const fetchWorkingOrder = (meta: { loadCart?: LoadWorkingOrderAction["payload"] }) => (dispatch, getState) => {
    let campaignId = null;
    if (me.isBuyer()) {
        const name = `user_${me._id}_campaign_for_${getState().scope?.brand?._id}`;
        const cookies = cookie.select(new RegExp(name));
        campaignId = cookies?.[name] || null;
    }
    dispatch({ type: WORKING_ORDER.ORDER.FETCH.START, payload: _.omitBy({ campaignId }, _.isNil), meta });
};

export const updateWorkingOrder = (payload: IWorkingOrder) => ({ type: WORKING_ORDER.ORDER.UPDATE, payload });
